import { render, staticRenderFns } from "./work_detail.vue?vue&type=template&id=6c82f01e&scoped=true"
import script from "./work_detail.vue?vue&type=script&lang=js"
export * from "./work_detail.vue?vue&type=script&lang=js"
import style0 from "./work_detail.vue?vue&type=style&index=0&id=6c82f01e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82f01e",
  null
  
)

export default component.exports